import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const statusStyles = {
  failed: {
    background: 'var(--color-error-bg, rgba(239, 68, 68, 0.1))',
    color: 'var(--color-error, #ef4444)',
    borderColor: 'var(--color-error, #ef4444)',
  },
  incomplete: {
    background: 'var(--color-warning-bg, rgba(245, 158, 11, 0.1))',
    color: 'var(--color-warning, #f59e0b)',
    borderColor: 'var(--color-warning, #f59e0b)',
  },
  cancelled: {
    background: 'var(--color-neutral-100, rgba(0, 0, 0, 0.06))',
    color: 'var(--color-body-muted, #666)',
    borderColor: 'var(--color-neutral-200, rgba(0, 0, 0, 0.1))',
  },
};

export const Banner = styled.div`
  padding: ${(props) => props.theme.spacing?.sm ?? '8px'} ${(props) => props.theme.spacing?.md ?? '12px'};
  border-radius: ${(props) => props.theme.borderRadius?.base ?? '8px'};
  border: 1px solid;
  font-size: ${(props) => props.theme.fonts?.size?.b2 ?? '14px'};
  animation: ${fadeIn} 0.3s ease-out;

  ${(props) => {
    const styles = statusStyles[props.$status] ?? statusStyles.failed;
    return `
      background: ${styles.background};
      color: ${styles.color};
      border-color: ${styles.borderColor};
    `;
  }}
`;
